// src/BreakpointDetection.tsx
import { useTheme } from "@mui/joy/styles";
import useMediaQuery from "@mui/system/useMediaQuery";
import { useEffect } from "react";
import { create } from "zustand";
var breakpoints = (() => {
  const breakpointRecord = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
  };
  const keys = Object.keys(breakpointRecord);
  return keys.sort((a, b) => breakpointRecord[a] - breakpointRecord[b]);
})();
var useBreakpointDetectionStore = create((_set, get) => ({
  breakpoint: "xs",
  isGreater: (breakpoint) => {
    return breakpoints.indexOf(get().breakpoint) > breakpoints.indexOf(breakpoint);
  },
  isGreaterOrEqual: (breakpoint) => {
    return breakpoints.indexOf(get().breakpoint) >= breakpoints.indexOf(breakpoint);
  }
}));
var BreakpointDetection = () => {
  const theme = useTheme();
  for (const breakpoint of theme.breakpoints.keys) {
    const isMediaQuery = useMediaQuery(theme.breakpoints.only(breakpoint));
    useEffect(() => {
      if (isMediaQuery) {
        useBreakpointDetectionStore.setState({ breakpoint });
      }
    }, [isMediaQuery]);
  }
  return null;
};
var BreakpointDetection_default = BreakpointDetection;

export {
  useBreakpointDetectionStore,
  BreakpointDetection_default
};
